const UPI_ID_RE = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9][a-zA-Z0-9.-]*$/;

export function looksLikeUpiId(value) {
  const v = (value || "").trim();
  if (!v || /^https?:\/\//i.test(v)) return false;
  return UPI_ID_RE.test(v);
}

/** Single display/storage value from legacy split fields. */
export function combinedPaymentValue({ payment_link, payment_upi } = {}) {
  return (payment_link || payment_upi || "").trim();
}

/** Map one user-facing field into payment_link + payment_upi. */
export function splitPaymentValue(raw) {
  const value = (raw || "").trim();
  if (!value) return { payment_link: "", payment_upi: "" };
  if (looksLikeUpiId(value)) return { payment_link: "", payment_upi: value };
  return { payment_link: value, payment_upi: "" };
}

/** Build the string encoded in a payment QR code. */
export function paymentQrValue({ payment_link, payment_upi, amount, currency, payeeName }) {
  const link = (payment_link || "").trim();
  if (link && !looksLikeUpiId(link)) return link;
  const upi = (payment_upi || "").trim() || (looksLikeUpiId(link) ? link : "");
  if (!upi) return null;
  const params = new URLSearchParams({ pa: upi });
  if (payeeName) params.set("pn", payeeName);
  if (amount != null && Number(amount) > 0) {
    params.set("am", String(amount));
    params.set("cu", currency || "INR");
  }
  return `upi://pay?${params.toString()}`;
}

export function hasPaymentMethod(sp) {
  if (!sp) return false;
  return Boolean(combinedPaymentValue(sp));
}

export const DEFAULT_PAYMENT_INSTRUCTIONS =
  "1. Pay using the link or QR above.\n2. Share the payment screenshot with the host.";

export function emptyPaymentFields(organizer) {
  const dp = organizer?.default_payment || {};
  return {
    payment_link: dp.payment_link || "",
    payment_upi: dp.payment_upi || "",
    instructions: dp.instructions || DEFAULT_PAYMENT_INSTRUCTIONS,
    contact_phone: dp.contact_phone || organizer?.phone || "",
    contact_email: dp.contact_email || organizer?.email || "",
    contact_telegram: dp.contact_telegram || "",
  };
}

/** Payment fields used for validation/display when profile defaults are enabled. */
export function resolveFormSelfPayment(sp = {}, organizer) {
  const useProfile = sp.use_profile_defaults !== false;
  if (useProfile && organizer) {
    return { use_profile_defaults: true, ...emptyPaymentFields(organizer) };
  }
  return { ...sp, use_profile_defaults: false };
}
